export default __webpack_public_path__ + "static/media/arabic.502f74a3.svg";